import React from "react";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 z-0">
      <img src={image} alt={`${title} — K.O Chef & Catering, Southwest Florida`} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
    </div>
    <div className="container-lux relative z-10 text-center">
      <Reveal><p className="overline mb-5">{overline}</p></Reveal>
      <Reveal delay={0.1}><h1 className="text-4xl md:text-6xl font-light text-white leading-tight">{title}</h1></Reveal>
      {subtitle && <Reveal delay={0.2}><p className="mt-6 text-lg text-white/60 max-w-2xl mx-auto">{subtitle}</p></Reveal>}
      <Reveal delay={0.3}><div className="gold-line mx-auto mt-8" /></Reveal>
    </div>
  </section>
);

export default PageHero;
